export const NotFound =()=>{
  return(
    <>
    <h1>お探しのページは見つかりません</h1>
    </>
  )
}

export default NotFound;
